import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { buffer, catchError, map,of, Observable, Subject, Subscription, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { delay, mergeMap, switchMap } from 'rxjs/operators';

import {timer } from 'rxjs';
import {  retryWhen, scan, delayWhen } from 'rxjs/operators';
import { DataServiceService } from './data-service.service';
@Injectable({
  providedIn: 'root'
})
export class ApiservicesService {
  public baseUrl: any = environment.api_url;
  public jwtToken: string = '';
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: '',
    }),
  };
  // httpOptions2 = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'authorization': 'Basic ' + btoa(environment.username + ':' + environment.password),
  //   })
  // }

  httpOptions3 = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  }


  httpOptionsroomID = {
    headers: new HttpHeaders({
        'authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiIyY2ZlNzA0Yy00MTlhLTQ5NWQtYTIyMi01ZTk3MWNlNDdlZTQiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTY5NzQzMTAxNSwiZXhwIjoxNjk3NTE3NDE1fQ.N6g6dhz0I1l3l4a2mqMWA1lM8-_6VvdT0HaL59VXIwM`,
        "Content-Type": "application/json",
    })
  }

  constructor(private http: HttpClient, private cookieService: CookieService,private dataService: DataServiceService) { }
  public getHttpData(url: any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${user_info.token}`,
      })
    }
    return this.http.get<any>(this.baseUrl + url, this.httpOptions).pipe(
      catchError((error) => {
        // this.openSnackBar();
        console.log('error --->', error);
        return throwError(() => new Error(error));
      })
    );
  }
  public getHttpDatalogin(url: any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      // const user_info = this.cookieService.get('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      // console.log("user_info",user_info);
      
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        // "authorization": `Bearer ${user_info.token}`,
      })
    }
    return this.http.get<any>(this.baseUrl + url, this.httpOptions).pipe(
      catchError((error) => {
        // this.openSnackBar();
        console.log('error --->', error);
        return throwError(() => new Error(error));
      })
    );;
  }

  public getHttpDataWithoutBaseUrl(url: any): Observable<any> {
    return this.http.get<any>(url).pipe(
      catchError((error) => {
        // this.openSnackBar();
        console.log('error --->', error);
        return throwError(() => new Error(error));
      })
    );;
  }

  // public getHttpDataPost(url: any, body: any): Observable<any> {
  //   if (!environment.unauthorized_routes.includes(url)) {
  //     const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
  //     if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
  //     this.httpOptions.headers = new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       "authorization": `Bearer ${user_info.token}`,
  //     })
  //   }
  //   return this.http.post<any>(this.baseUrl + url, JSON.stringify(body), this.httpOptions).pipe(
  //     catchError((error) => {
  //       // this.openSnackBar();

  //       return throwError(() => error.error);
  //     })
  //   )
  // }
public getHttpDataPost(url: any, body: any): Observable<any> {
  if (!environment.unauthorized_routes.includes(url)) {
    const user_info = this.cookieService.check('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : undefined;

    if (!user_info) {
      return throwError(() => ({ message: 'Need to Login' }));
    }

    this.httpOptions.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `Bearer ${user_info.token}`,
    });
  }

  return this.http.post<any>(this.baseUrl + url, JSON.stringify(body), this.httpOptions).pipe(
    retryWhen(errors =>
      errors.pipe(
        mergeMap((error, retryCount) => {
          if (error.status === 429 && retryCount < 5) {
            // Wait 1 second before retry
            return timer(1000);
          }
          // If not 429 or exceeded retries, throw error
          return throwError(() => error.error || error);
        })
      )
    ),
    catchError((error) => {
      return throwError(() => error.error || error);
    })
  );
}





  public getHttpDataPostNoLogin(url: any, body: any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      // const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      // if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        // "authorization": `Bearer ${user_info.token}`,
      })
    }
    return this.http.post<any>(this.baseUrl + url, JSON.stringify(body), this.httpOptions).pipe(
      catchError((error) => {
        // this.openSnackBar();

        return throwError(() => error.error);
      })
    )
  }









  public getHttpDataPostcalendarADD(url: any, body: any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${user_info.token}`,
      })
    }
    return this.http.post<any>('https://m9mkuic6o9.execute-api.us-east-1.amazonaws.com/dev/' + url, JSON.stringify(body), this.httpOptions).pipe(
      catchError((error) => {
        // this.openSnackBar();

        return throwError(() => error.error);
      })
    )
  }

  public getHttpDataPostcalendar(url: any, body: any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${user_info.token}`,
      })
    }
    return this.http.post<any>('https://i526y91jwg.execute-api.us-east-2.amazonaws.com/dev/' + url, JSON.stringify(body), this.httpOptions).pipe(

 
      catchError((error) => {
        // this.openSnackBar();

        return throwError(() => error.error);
      })
    )
  }


  public getHttpDatacalendar(url: any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${user_info.token}`,
      })
    }
    return this.http.get<any>('https://i526y91jwg.execute-api.us-east-2.amazonaws.com/dev/' + url, this.httpOptions).pipe(
      catchError((error) => {
        // this.openSnackBar();
        console.log('error --->', error);
        return throwError(() => new Error(error));
      })
    );
  }




  public getHttpDatalocation(url: any,body:any): Observable<any> {
    if (!environment.unauthorized_routes.includes(url)) {
      const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
      if (!user_info) return throwError(() => ({ 'message': "Need to Login" }));
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${user_info.token}`,
      })
    }
      return this.http.post<any>(this.baseUrl + url, JSON.stringify(body),this.httpOptions).pipe(
      catchError((error) => {
       return throwError(() => new Error(error));
      })
    );
  }





  public getHttpDataPostWithoutBaseUrl (url: any,body:any): Observable<any> {
    let httpOptions2 = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
     
        })
      }
    return this.http.post<any>(url, body,httpOptions2).pipe(
      catchError((error) => {
        // this.openSnackBar();
            console.log("this is login error",error);
            
        return throwError(()=>error.error);
      })
    )
  }


private getRandomApiKey(): string | null {
    const keys = environment?.freeastrologyapiKey ?? [];
    if (!Array.isArray(keys) || keys.length === 0) return null;
    const idx = Math.floor(Math.random() * keys.length);
    return keys[idx];
  }

  public postFreeAstroapi (url: any,body:any): Observable<any> {
     let headers = new HttpHeaders({ 'Content-Type': 'application/json' ,'origin': 'https://divineinfinitebeing.influxiq.com', 'Areferer': 'https://divineinfinitebeing.influxiq.com/' });

    const apiKey = this.getRandomApiKey();
    if (apiKey) {
      headers = headers.set('x-api-key', apiKey); // HttpHeaders is immutable
    } else {
      console.warn('No API keys configured in environment.apiKeys');
    }

    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error) => {
        console.log('this is login error', error);
        return throwError(() => error?.error ?? error);
      })
    );
  
  }

  private currentAstrologyKeyIndex = 0;

  private getAstrologyApiKeys(): string[] {
    const configuredKeys = (environment as any)?.astrologyapi_keys;
    if (Array.isArray(configuredKeys)) {
      const valid = configuredKeys.filter(
        (k: string) => typeof k === 'string' && k.trim().length > 0
      );
      if (valid.length > 0) return valid;
    }
    return ['ak-f1696f4f4098d456876f1f52fdb6877e29b04221'];
  }

  public getHttpHoroscopePost(url: any, body: any, attemptCount: number = 0): Observable<any> {
    console.log("astro_key", body);

    const keys = this.getAstrologyApiKeys();
    if (attemptCount >= keys.length) {
      console.error("All astrology API keys failed or exhausted");
      return throwError(() => new Error("All astrology API keys failed or exhausted"));
    }

    const currentKey = keys[this.currentAstrologyKeyIndex % keys.length];

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Basic ' + btoa(':' + currentKey),
        'Accept-Language': 'en'
      })
    };

    const isLocalhost =
      typeof window !== 'undefined' && window.location.hostname === 'localhost';
    const targetUrl = isLocalhost
      ? '/api-astrology/' + url
      : environment.astrology_api_url + url;

    return this.http.post<any>(targetUrl, JSON.stringify(body), httpOptions).pipe(
      catchError((error) => {
        // Fallback to direct URL if local dev-server proxy is not yet active (e.g. before restarting ng serve)
        if (isLocalhost && targetUrl.startsWith('/api-astrology/') && error.status === 404) {
          return this.http.post<any>(environment.astrology_api_url + url, JSON.stringify(body), httpOptions);
        }
        return throwError(() => error);
      }),
      switchMap((response: any) => {
        // If AstrologyAPI returns an error object e.g. { status: false, msg: "..." }
        if (response && response.status === false) {
          console.warn(`Astrology API returned error with key [${currentKey.slice(0, 8)}...]:`, response?.msg);
          if (attemptCount + 1 < keys.length) {
            this.currentAstrologyKeyIndex = (this.currentAstrologyKeyIndex + 1) % keys.length;
            console.log(`Rotating to next astrology token (index ${this.currentAstrologyKeyIndex})...`);
            return this.getHttpHoroscopePost(url, body, attemptCount + 1);
          }
          return throwError(() => response);
        }
        return of(response);
      }),
      catchError((error) => {
        console.warn(`Astrology API call failed with key [${currentKey.slice(0, 8)}...]:`, error);
        if (attemptCount + 1 < keys.length) {
          this.currentAstrologyKeyIndex = (this.currentAstrologyKeyIndex + 1) % keys.length;
          console.log(`Rotating to next astrology token (index ${this.currentAstrologyKeyIndex})...`);
          return this.getHttpHoroscopePost(url, body, attemptCount + 1);
        }
        return throwError(() => error);
      })
    );

    /* --- PREVIOUS CODE (COMMENTED OUT AS REQUESTED) ---
    try{
      let astro_key = JSON.parse(this.cookieService.get('astro_key_values'))
      // console.log("astro_key hereee      ",astro_key,url);
      
      let httpOptions2 = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': 'Basic ' + btoa(astro_key.access_key + ':' + astro_key.secret_key),
           'Accept-Language': 'en' 
        })
      }
      
  
  
      return this.http.post<any>(environment.astrology_api_url + url, JSON.stringify(body), httpOptions2).pipe(
        catchError((error) => {
  
  
          this.getHttpData('astro_decan_new_infos/get-astro-toolkit').subscribe({
            next: (response) => {
              console.log("astro_decan_new_infos/get-astro-toolkit",response);
              
              let obj = { 
                "access_key":response.results.access_key,
                "secret_key":response.results.secret_key
              }
              this.cookieService.set('astro_key_values',JSON.stringify(obj),{ path: '/', });
            }
          })
          // this.openSnackBar();
          return of(null).pipe(
            delay(2000),  // 2-second delay
            switchMap(() => this.getHttpHoroscopePost(url, body)) // Retry the function
          )
          // return  throwError(() => error.error)
        })
      )

    }catch{
      this.getHttpDatalogin('astro_decan_new_infos/get-astro-toolkit').subscribe({
        next: (response) => {
          console.log("astro_decan_new_infos/get-astro-toolkit",response);
          
          let obj = { 
            "access_key":response.results.access_key,
            "secret_key":response.results.secret_key
          }
          this.cookieService.set('astro_key_values',JSON.stringify(obj),{ path: '/', });
        }
      })
      // this.openSnackBar();
      return of(null).pipe(
        delay(2000),  // 2-second delay
        switchMap(() => this.getHttpHoroscopePost(url, body)) // Retry the function
      )
    }
    --- END PREVIOUS CODE --- */
  }

  public getRoomIDPost(): Observable<any> {
    return this.http.post<any>('https://api.videosdk.live/v2/rooms',JSON.stringify({}),this.httpOptionsroomID).pipe(
      catchError((error) => {
        // this.openSnackBar();
        return throwError(() => error.error);
      })
    )
  }


  // public getHttpNewHoroscopePost(body: any): Observable<any> {
  //   // const user_info = this.cookieService.check('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : undefined
  //   // if (user_info) {
  //   //   this.httpOptions.headers = new HttpHeaders({
  //   //     'Content-Type': 'application/json',
  //   //     "authorization": `Bearer ${user_info.token}`,
  //   //   })
  //   // }

  //   console.log("httpOptions", body);





  //   return this.http.post<any>(environment.new_astrology_api_url, JSON.stringify(body), this.httpOptions3).pipe(
  //     catchError((error) => {
  //       console.log("error in astro api", error);
        
  //       // this.openSnackBar();
  //       return throwError(() => error.error);
  //     })
  //   )
  // }

//   public getHttpNewHoroscopePost(body: any): Observable<any> {
//   console.log("httpOptions", body);

//   return this.http.post<any>(environment.new_astrology_api_url, JSON.stringify(body), this.httpOptions3).pipe(
//     retryWhen(errors =>
//       errors.pipe(
//         scan((retryCount, error) => {
//           if (error.status === 0 && retryCount < 5) {
//             retryCount++;
//             console.warn(`Retrying API call... Attempt #${retryCount}`);
//             return retryCount;
//           } else {
//             throw error;
//           }
//         }, 0),
//         delayWhen(() => timer(1000)) // 1-second delay between retries
//       )
//     ),
//     catchError((error) => {
//       console.error("error in astro api", error);
//       return throwError(() => error.error || error);
//     })
//   );
// }


public getHttpNewHoroscopePost(body: any): Observable<any> {
  console.log("httpOptions", body);

  const area_of_inquiry = this.dataService.getValue<string>('area_of_inquiry');

  console.log("area_of_inquiry token", area_of_inquiry);
  

 if (body && typeof body === 'object' && body.condition && body.condition.system_content) {
   
    body.condition.system_content += ". Provide a deeply personalized response as if you are speaking directly to your astrology client in a one-on-one session. Use the language and tone of a trusted Western astrologer offering tailored guidance based on the client’s unique chart. Always interpret the chart using the Placidus house system as the default house_type. Avoid using generic phrases or repeated sentence structures. Each sentence should feel intentionally crafted and distinct, offering fresh insight without duplicating wording from similar interpretations.";

 
    if (area_of_inquiry) {
      let trimmedInquiry = area_of_inquiry.trim()
      body.condition.system_content += `\n\nThe user has provided a specific "Area of Inquiry": "${trimmedInquiry}". Make this the central theme of your interpretation. While you should ground the reading in this context, also incorporate other relevant insights from the chart that support or add nuance to this primary focus. Conclude the response by explicitly summarizing how the various astrological insights tie back to the client’s stated area of inquiry.`;
    }


  }
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost';
  const targetUrl = isLocalhost
    ? '/api-new-astrology'
    : environment.new_astrology_api_url;

  return this.http.post<any>(targetUrl, JSON.stringify(body), this.httpOptions3).pipe(
    catchError((error) => {
      // Fallback to direct URL if local dev proxy is not yet active (e.g. before ng serve restart)
      if (isLocalhost && targetUrl === '/api-new-astrology' && error.status === 404) {
        return this.http.post<any>(environment.new_astrology_api_url, JSON.stringify(body), this.httpOptions3);
      }
      return throwError(() => error);
    }),
    // Retry logic for network failures (status === 0)
    retryWhen(errors =>
      errors.pipe(
        scan((retryCount, error) => {
          if (error.status === 0 && retryCount < 5) {
            retryCount++;
            console.warn(`Retrying API call... Attempt #${retryCount}`);
            return retryCount;
          } else {
            throw error;
          }
        }, 0),
        delayWhen(() => timer(1000)) // wait 1 second between retries
      )
    ),

    switchMap((res: any) => {
      let aiResponse = res?.ai_response?.trim();
      if (aiResponse?.startsWith("```json")) {
        aiResponse = aiResponse.replace(/^```json\s*/, "").trim();
        if (aiResponse.endsWith("```")) {
          aiResponse = aiResponse.replace(/```$/, "").trim();
        }
        res.ai_response = aiResponse;
      }


      return of(res); // return original response
    }),

    // Final error handling
    catchError((error) => {
      console.error("Final error in astro API:", error);
      return throwError(() => error.error || error);
    })
  );
}


  httpViaPost(endpoint: any, jsonData: any): Observable<any> {
    // console.log("{{}{}{",jsonData);

    /* set common header */
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': this.jwtToken
      })
    };
    return this.http.post(this.baseUrl + endpoint, jsonData, httpOptions)

  }


}
